import React from "react";
import EditProfileData from "./EditProfileData";

function EditProfile() {
  return (
    <div className="min-h-screen py-8 px-4 sm:px-6 lg:px-8 max-sm:mt-2 max-md:mt-8">
      <div className="mx-auto">
        <EditProfileData />
      </div>
    </div>
  );
}

export default EditProfile;
